export const Loading = (_props: any) => <div>Loading...</div>;
